<template>
  <div class="fx-component-upload-btn">
    <span
      @click="upload"
      class="btn-container"
    >
      <slot></slot>
    </span>
    <input
      ref="fileRef"
      v-show="false"
      :multiple="multiple"
      type="file"
      @change="accessFile"
    >
    <input
      ref="folderRef"
      v-show="false"
      webkitdirectory
      directory
      type="file"
      @change="accessFile"
    >
  </div>
</template>
<script>
export default {
  name: 'upload-btn',
  props: {
    type: {
      type: String,
      default: 'file', // 'folder'
      required: false
    },
    multiple: {
      type: Boolean,
      default: true,
      required: false
    },
  },
  data() {
    return {}
  },
  mounted() {
  },
  methods: {
    upload() {
      if(this.type=='file') {
        this.$refs.fileRef.click();
      } else if(this.type=='folder') {
        this.$refs.folderRef.click();
      }
    },
    accessFile(e) {
      this.$emit('change',e)
    }
  }
}
</script>
<style lang="scss" scoped>
.fx-component-upload-btn {
  display: inline-block;
  .btn-container {
    display: inline-block;
  }
}
</style>

